import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <main className="not-found-page">
      <span>404</span>
      <h1>Questa pagina non esiste.</h1>
      <p>Il link potrebbe essere cambiato oppure la risorsa non è ancora disponibile.</p>
      <Link className="button button-primary" to="/app"><ArrowLeft size={16} /> Torna al workspace</Link>
    </main>
  );
}
